/** User-facing name for the premium subscription tier. */
export const PRO_TIER_NAME = 'Peak Performance IQ Pro';
